export const getCreditPacks = async () => {
  const { data, error } = await packsCatalogue();
  if (error) {
    console.log('❌ Error getting credit packs', error);
    return [];
  }
  return (data?.credit_packs ?? []).map((pack) => ({
    credits: pack.credits,
    id: pack.id,
    name: pack.name,
    price: pack.price,
    displayOrder: pack.display_order,
    description: pack.description,
    status: pack.status,
  }));
};
